import { useEffect, useState } from "react";

export default function ProgressBar() {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // Listen for page navigation events
    const handleStart = () => setIsLoading(true);
    const handleComplete = () => setIsLoading(false);

    // Listen for clicks on links and form submissions
    const handleClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const link = target.closest("a");
      if (link && link.href && !link.href.startsWith("#") && !link.target) {
        setIsLoading(true);
        // Reset after a short delay in case navigation doesn't happen
        setTimeout(() => setIsLoading(false), 1000);
      }
    };

    document.addEventListener("click", handleClick);
    window.addEventListener("beforeunload", handleStart);
    window.addEventListener("load", handleComplete);

    return () => {
      document.removeEventListener("click", handleClick);
      window.removeEventListener("beforeunload", handleStart);
      window.removeEventListener("load", handleComplete);
    };
  }, []);

  if (!isLoading) return null;

  return (
    <div className="fixed top-0 left-0 h-1 bg-orange-500 z-50 animate-pulse">
      <div
        className="h-full bg-orange-600 animate-pulse"
        style={{ width: "30%" }}
      />
    </div>
  );
}
